import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'filter',
  name: 'Filter',
  category: 'utilities',
  description: 'Filter items based on conditions - keep or remove items that match',
  icon: 'Filter',
  color: 'cyan',
  version: '2.2.0',
  
  group: ['transform'],
  
  defaults: {
    name: 'Filter',
    color: '#06b6d4'
  },
  
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true
    }
  ],
  
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output'
    }
  ],
  
  tags: ['filter', 'condition', 'where', 'query', 'match'],
  
  comingSoon: false,
  
  metadata: {
    documentation: 'https://docs.n8n.io/integrations/builtin/core-nodes/n8n-nodes-base.filter/'
  }
};

export default definition;
